<div class="wk-cm__header">
    <h1
        class="wk-cm__header-title"
        aria-hidden="true"
        (click)="handleOpenInApp($event)"
        (keydown.enter)="handleOpenInApp($event)"
        (mouseover)="isEllipsisActive($event)"
        (focus)="isEllipsisActive($event)"
    >
        <span class="wk-cm__header-title-text">{{ cardModalService.currentCard()! | cardTitle }}</span>

        @if (isTaxpayerNameOverflow) {
            <tooltip-pds3
                elementId="h_taxpayer_name"
                mode="indicator"
                [openDelay]="600"
                [closeDelay]="50"
                position="right"
                targetSelector=".wk-cm__header-title"
            >
                {{ cardModalService.currentCard()! | cardTitle }}
            </tooltip-pds3>
        }

        @if (cardModalService.filenameFull()?.length > 0) {
            <tooltip-pds3
                elementId="h_file_name"
                mode="indicator"
                position="bottom"
                targetSelector=".wk-cm__header-title"
                [openDelay]="600"
                [closeDelay]="50"
            >
                {{ cardModalService.filenameFull() }}
            </tooltip-pds3>
        }

        @if (!isJobsBillingNorthPanelVisible) {
            <wk-icon-link-external-sprite-pds3 />
            <icon-pds3 name="wk-icon-link-external" />
        } @else {
            <wk-jobs-billing-north-panel />
        }
    </h1>

    @if (isTaxPrepNorthPanelVisible) {
        <wk-taxprep-north-panel />
    } @else if (isIFirmTaxprepNorthPanelVisible) {
        <wk-ifirmtaxprep-north-panel />
    }

    <div class="wk-cm__header-popup">
        <wk-icon-filled-more-sprite-pds3 />
        <icon-pds3 name="wk-icon-filled-more" />

        <dropdown-pds3 targetSelector=".wk-cm__header-popup">
            <dropdown-list-pds3>
                <dropdown-item-list-pds3 *dropdownListItemPds3>
                    <dropdown-category-title-pds3>{{ "CardModal.Tools" | translate }}</dropdown-category-title-pds3>
                    <dropdown-list-pds3>
                        <dropdown-item-field-pds3 *dropdownListItemPds3 elementId="btn_audit_trail" aria-hidden="true">
                            <button type="button" (click)="handleOpenAudit()" (keydown.enter)="handleOpenAudit()">
                                <wk-icon-process-list-sprite-pds3 />
                                <icon-pds3 name="wk-icon-process-list" />
                                <span>{{ "CardModal.AuditTrail" | translate }}</span>
                            </button>
                        </dropdown-item-field-pds3>
                        @if (!isJobsBillingNorthPanelVisible) {
                            <dropdown-item-field-pds3 *dropdownListItemPds3 elementId="btn_vip" aria-hidden="true">
                                <button type="button" (click)="handleVipChange()" (keydown.enter)="handleVipChange()">
                                    <wk-icon-trophy-sprite-pds3 />
                                    <icon-pds3 name="wk-icon-trophy" />
                                    <span>{{ (cardModalService.isVIP() ? "CardModal.DeleteVIP" : "CardModal.MarkVIP") | translate }}</span>
                                </button>
                            </dropdown-item-field-pds3>
                        }
                    </dropdown-list-pds3>
                </dropdown-item-list-pds3>
                @if (!isTaxPrepNorthPanelVisible) {
                    <dropdown-item-list-pds3 *dropdownListItemPds3>
                        <dropdown-category-title-pds3>{{ "CardModal.Links" | translate }}</dropdown-category-title-pds3>
                        <dropdown-list-pds3>
                            <dropdown-item-field-pds3 *dropdownListItemPds3 elementId="btn_open_in_contact" aria-hidden="true">
                                <button type="button" (click)="handleOpenInContact()" (keydown.enter)="handleOpenInContact()">
                                    <wk-icon-link-external-sprite-pds3 />
                                    <icon-pds3 name="wk-icon-link-external" />
                                    <span>Contact</span>
                                </button>
                            </dropdown-item-field-pds3>
                            @if (
                                !isJobsBillingNorthPanelVisible ||
                                (cardModalService.currentCard()?.return && cardModalService.currentCard()?.return?.documentId)
                            ) {
                                <dropdown-item-field-pds3 *dropdownListItemPds3 elementId="btn_open_in_portal" aria-hidden="true">
                                    <button type="button" (click)="handleOpenInPortal()" (keydown.enter)="handleOpenInPortal()">
                                        <wk-icon-link-external-sprite-pds3 />
                                        <icon-pds3 name="wk-icon-link-external" />
                                        <span>{{ "CardModal.Portal" | translate }}</span>
                                    </button>
                                </dropdown-item-field-pds3>
                            }
                            @if (
                                isJobsBillingNorthPanelVisible &&
                                cardModalService.currentCard()?.return?.productType !== "" &&
                                cardModalService.currentCard()?.return?.documentId !== ""
                            ) {
                                <dropdown-item-field-pds3 *dropdownListItemPds3 elementId="btn_open_in_ifirmportal" aria-hidden="true">
                                    <button type="button" (click)="handleOpenIniFirmTaxprep()" (keydown.enter)="handleOpenIniFirmTaxprep()">
                                        <wk-icon-link-external-sprite-pds3 />
                                        <icon-pds3 name="wk-icon-link-external" />
                                        <span>iFirm Taxprep</span>
                                    </button>
                                </dropdown-item-field-pds3>
                            }
                        </dropdown-list-pds3>
                    </dropdown-item-list-pds3>
                }

                <dropdown-item-separator-pds3 *dropdownListItemPds3 />

                <dropdown-item-list-pds3 *dropdownListItemPds3>
                    @if (userCanDeleteCard) {
                        <ng-container>
                            <dropdown-category-title-pds3>{{ "CardModal.Other" | translate }}</dropdown-category-title-pds3>
                            <dropdown-list-pds3>
                                <dropdown-item-field-pds3 *dropdownListItemPds3 aria-hidden="true">
                                    <button type="button" color="danger" (click)="handleDeleteCard()" (keydown.enter)="handleDeleteCard()">
                                        <wk-icon-trash-sprite-pds3 />
                                        <icon-pds3 name="wk-icon-trash" />
                                        <span>{{ "CardModal.DeleteCard" | translate }}</span>
                                    </button>
                                </dropdown-item-field-pds3>
                            </dropdown-list-pds3>
                        </ng-container>
                    }
                </dropdown-item-list-pds3>
            </dropdown-list-pds3>
        </dropdown-pds3>
    </div>
</div>
<wk-panel-icons />
